/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function ComponentFilledIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="component-filled"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M2.566 11.434C2.253 11.747 2.253 12.253 2.566 12.566L5.184 15.184C5.497 15.497 6.003 15.497 6.316 15.184L8.934 12.566C9.247 12.253 9.247 11.747 8.934 11.434L6.316 8.816C6.003 8.503 5.497 8.503 5.184 8.816L2.566 11.434Z" data-tinysvg-shape="path" stroke={color} fill={color} data-stroke-tone="primary" data-fill-tone="primary" />
          <path d="M21.434 11.434C21.747 11.747 21.747 12.253 21.434 12.566L18.816 15.184C18.503 15.497 17.997 15.497 17.684 15.184L15.066 12.566C14.753 12.253 14.753 11.747 15.066 11.434L17.684 8.816C17.997 8.503 18.503 8.503 18.816 8.816L21.434 11.434Z" data-tinysvg-shape="path" stroke={color} fill={color} data-stroke-tone="primary" data-fill-tone="primary" />
          <path d="M11.434 21.434C11.747 21.747 12.253 21.747 12.566 21.434L15.184 18.816C15.497 18.503 15.497 17.997 15.184 17.684L12.566 15.066C12.253 14.753 11.747 14.753 11.434 15.066L8.816 17.684C8.503 17.997 8.503 18.503 8.816 18.816L11.434 21.434Z" data-tinysvg-shape="path" stroke={color} fill={color} data-stroke-tone="primary" data-fill-tone="primary" />
          <path d="M11.434 2.566C11.747 2.253 12.253 2.253 12.566 2.566L15.184 5.184C15.497 5.497 15.497 6.003 15.184 6.316L12.566 8.934C12.253 9.247 11.747 9.247 11.434 8.934L8.816 6.316C8.503 6.003 8.503 5.497 8.816 5.184L11.434 2.566Z" data-tinysvg-shape="path" stroke={color} fill={color} data-stroke-tone="primary" data-fill-tone="primary" />
    </svg>
  )
}
